import { methods } from "@streamlabs-core/sl-one-fe-sdk";
import AnalyticHelper, { EAnalyticsEvent } from "./analytic";

const ULTRA_FREE_TRIAL_CODE = 'consoleultra7';

export const generateCancelUrl = async () => {
  const { redirect_url } = await methods.getUltraUnsubscribeUrl();
  return redirect_url;
};

export const generateChangePaymentMethodUrl = async () => {
  const { redirect_url } = await methods.getPaymentMethodUrl();
  return redirect_url;
};

export const generateSubscribeUrl = async (freeTrial = false) => {
  let { redirect_url } = await methods.getUltraSubscribeUrl();

  if (freeTrial)
    redirect_url += `&promo=${ULTRA_FREE_TRIAL_CODE}`;

  return redirect_url;
};

export const changeUltraPaymentMethod = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      await methods.openUltraSubscribePopout({
        url: generateChangePaymentMethodUrl(),
        onLogin: (data) => {
          reject();
        },
        onSwitchUser: (data) => {
          reject();
        },
        onSubscribed: (data) => {
          resolve(true);
        },
      });
    } catch (err) {
      console.error(err);
      reject();
    }
  });
};

export const cancelUltra = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      await methods.openUltraSubscribePopout({
        url: generateCancelUrl(),
        onLogin: (data) => {
          reject();
        },
        onSwitchUser: (data) => {
          reject();
        },
        onSubscribed: (data) => {
          resolve(true);
        },
      });
    } catch (err) {
      console.error(err);
      reject();
    }
  });
};

export const subscribeToUltra = async (freeTrial: boolean = false) => {
  AnalyticHelper.sendEvent(
    freeTrial
      ? EAnalyticsEvent.checkoutUltraClickedFreeTrial
      : EAnalyticsEvent.checkoutUltraClicked,
    { freeTrial }
  );

  return new Promise(async (resolve, reject) => {
    try {
      await methods.openUltraSubscribePopout({
        url: await generateSubscribeUrl(freeTrial),
        onLogin: (data) => {
          reject();
        },
        onSwitchUser: (data) => {
          reject();
        },
        onSubscribed: (data) => {
          AnalyticHelper.sendEvent(EAnalyticsEvent.ultraBannerSuccess);
          resolve(true);
        },
      });
    } catch (err) {
      AnalyticHelper.sendEvent(EAnalyticsEvent.ultraBannerFailure, err);
      console.error(err);
      reject();
    }
  });
};